// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2vki6","large":"styles_large__3lhNl"};